export const progressData = [
  { title: "On-Time Deliveries", percentage: 100 },
  { title: "Global Network Coverage", percentage: 95 },
  { title: "Cross-Border Efficiency", percentage: 90 }
]